import { useEffect, useRef } from "react";

export const useMinSideBarMenu = ({setVisible, visible, clicMenu}) => {

    const ref = useRef();

    useEffect(() => {
        if(visible){
            const handleClickOutside = (event) => {
                if (visible && ref?.current && !ref.current.contains(event.target)) {
                    setVisible(false);
                    const idMenuRef = ref.current.id?.replace("Menu", "");
                    clicMenu?.(event, "OUTER","OUTER", idMenuRef);
                }
            };

            document.addEventListener('click', handleClickOutside, true);
            return () => {
                document.removeEventListener('click', handleClickOutside, true);
            };
        }
    }, [setVisible, visible, clicMenu]);

    return {
        ref
    }

}

